export const SUPPORT_CATEGORIES = [
  {
    value: 'Trading Issues',
    label: 'Trading Issues - Problems with trades, orders, execution',
  },
  {
    value: 'Account Issues',
    label: 'Account Issues - Login, verification, account settings',
  },
  {
    value: 'Payment Issues',
    label: 'Payment Issues - Deposits, withdrawals, transactions',
  },
  {
    value: 'Technical Issues',
    label: 'Technical Issues - Platform errors, bugs, performance',
  },
  {
    value: 'Other',
    label: 'Other - General inquiries and other issues',
  },
] as const;

export const SUPPORT_PRIORITIES = [
  {
    value: 'Low',
    label: 'Low - Non-urgent, can wait',
  },
  {
    value: 'Medium',
    label: 'Medium - Normal priority',
  },
  {
    value: 'High',
    label: 'High - Urgent, needs attention',
  },
  {
    value: 'Urgent',
    label: 'Urgent - Critical, immediate attention required',
  },
] as const;
